<template>
  <div class="container">
    <p style="text-align: center; font-weight: 700; font-size: 36px">
      河南农商银行获嘉支行
    </p>
    <p
      style="
        text-align: center;
        font-weight: 700;
        font-size: 36px;
        margin-bottom: 20px;
      "
    >
      金融助力乡村振兴
    </p>
    <p style="text-indent: 2em">
      河南农商银行获嘉支行为支持农业发展，助力乡村振兴，打通金融支持“快车道”，推出了一系列专属的贷款政策。企业及个人在进行各类农村产权交易时，可凭《获嘉县农村产权交易鉴证书》提出贷款需求，河南农商银行获嘉支行对提出贷款需求的企业及个人快审批、快放款，提供全方位、多层次的金融支持，成为众多企业及个人实现梦想的有力助推器。
    </p>
    <p style="text-indent: 2em">
      贷款对象:符合河南农商银行获嘉支行贷款基本条件，且取得获嘉县农村产权交易中心出具的《获嘉县农村产权交易鉴证书》的企业及个人。
    </p>
    <p style="text-indent: 2em">贷款额度:个人最高500万元、企业最高2000万元。</p>
    <p style="text-indent: 2em">担保方式:信用、保证、抵押、质押均可。</p>
    <p style="text-indent: 2em">
      贷款用途:按照《获嘉县农村产权交易鉴证书》所签订的用途使用贷款资金。
    </p>
    <p style="text-indent: 2em">
      贷款期限:根据《获嘉县农村产权交易鉴证书》内容中交易双方所签订的使用年限，制定合理的贷款期限。
    </p>
    <p style="text-indent: 2em">
      贷款流程：客户凭《获嘉县农村产权交易鉴证书》提出贷款申请→客户经理现场核实交易事实及规模的真实性并对贷款用户资质进行性调查→综合测算贷款额度并制定合理的贷款期限→上报审批→签订合同→贷款发放→贷后管理
    </p>
    <p style="text-indent: 2em">联系人：王士秀</p>
    <p style="text-indent: 2em">联系电话：0373-7095922</p>
    <br />
    <div class="imgBox">
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/合家好（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/金燕e商贷（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/农机贷（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/收储贷（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/养殖贷（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/种植（个人）.png"
        alt=""
        class="widthImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/农机贷（对公）.png"
        alt=""
        class="heightImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/收储贷（对公）.png"
        alt=""
        class="heightImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/养殖贷（对公）.png"
        alt=""
        class="heightImg"
      />
      <img
        src="../assets/金融服务/获嘉河南农商银行详情图片/种植贷（对公）.png"
        alt=""
        class="heightImg"
      />
    </div>
    <img src="@/assets/金融服务/河南农商银行.png" alt="" />
    <p style="text-align: center; font-weight: 700; font-size: 40px">
      获嘉支行产品明细表
    </p>
    <table border="1">
      <tr>
        <th>产品</th>
        <th>利率</th>
        <th>期限（月）</th>
        <th>额度（万元）</th>
      </tr>
      <tr>
        <td>养殖贷</td>
        <td>2.79‰起</td>
        <td>1至24</td>
        <td>1-500</td>
      </tr>
      <tr>
        <td>收储贷</td>
        <td>2.79‰起</td>
        <td>1至24</td>
        <td>1-1000</td>
      </tr>
      <tr>
        <td>农机贷</td>
        <td>2.79‰起</td>
        <td>1至36</td>
        <td>1-1000</td>
      </tr>
      <tr>
        <td>种植贷</td>
        <td>2.79‰起</td>
        <td>1至36</td>
        <td>1-300</td>
      </tr>
      <tr>
        <td>金燕e商贷</td>
        <td>2.79‰起</td>
        <td>1至36</td>
        <td>1-100</td>
      </tr>
      <tr>
        <td>合家好</td>
        <td>2.75‰起</td>
        <td>1至36</td>
        <td>1-300</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bankList: [
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  min-height: 630px;
  margin: 0 auto;
  width: 1500px;
  background-color: #fff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 30px 100px 80px;
  p {
    font-size: 22px;
    line-height: 2;
  }
  img {
    display: block;
    width: 400px;
    height: auto;
  }
  table {
    width: 100%;
    height: auto;
    margin-top: 50px;
    tr {
      height: 70px;
      th,
      td {
        text-align: center;
        font-size: 24px;
        font-weight: 500;
      }
    }
  }
  .imgBox {
    display: flex;
    flex-flow: row wrap;
    width: 100%;
    img {
      margin-bottom: 20px;
      display: block;
      box-shadow: 0px 0px 12px rgba(21, 21, 21, 0.1);
      &:nth-child(2n) {
        margin-left: 20px;
      }
    }
    .widthImg {
      width: calc(50% - 10px);
      height: auto;
    }
    .heightImg {
      width: calc(50% - 10px);
      height: auto;
    }
  }
}
</style>